
import { useSelector } from 'react-redux';
import CompHTML from '../widgets/CompHTML'

import { 
	getDataById
 } from '../../store/dataStateReducers';


const Header = (props) => {

	const login_id_js = useSelector( (state) => getDataById( state, 'login' ) );

	const name_app = login_id_js.data_js.name_app;
	// const name_uid = login_id_js.data_js.name_uid;
  
	const jsx = (
	<div>
		<p><b><CompHTML html={name_app} /></b></p>
	</div>
	);
  
	return jsx;
  };
  
  export default Header;
  